import React from 'react';

// Utils
import { revertImpersonatedUser } from '~/utils/auth.js';
import { MESSAGES } from '~/utils/message.js';
import ConfirmModal from '~/components/General/ConfirmModal';

// Icons
import { User2CIcon } from '~/assets/images';

const SwitchBackModal = (props) => {
  const { open, handleClose } = props;

  return (
    <ConfirmModal
      openConfirmModal={{
        open,
        header: 'Switch back to your account?',
        message: MESSAGES.ADMIN_DASHBOARD.USERS.IMPERSONATION.SWITCH_BACK_MODAL.HEADING,
        icon: User2CIcon,
        handleOk: revertImpersonatedUser,
        handleClose,
        successButtonName:
          MESSAGES.ADMIN_DASHBOARD.USERS.IMPERSONATION.SWITCH_BACK_MODAL.SUBMIT_BUTTON,
        cancelButtonName:
          MESSAGES.ADMIN_DASHBOARD.USERS.IMPERSONATION.SWITCH_BACK_MODAL.CANCEL_BUTTON,
        compactActions: true,
      }}
    />
  );
};

export default SwitchBackModal;
